import React from "react";
import { SimpleConfirmDialog } from "@duosoftbg/nacid-components";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import { closeModal } from "../../../../../store/redux/slice/ComponentsControl/lawControl";

const LawFormDeleteFileDialog = ({ methods, reloadLawFormComponent }) => {
  const dispatch = useAppDispatch();

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.lawControl.modals.delete;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "delete" }));
  };

  const confirm = () => {
    const files = methods.getValues("files");
    const newFiles = files.filter((file) => file.fileId !== id);
    methods.setValue("files", newFiles);
    handleCloseDialog();
    reloadLawFormComponent();
  };

  return (
    <SimpleConfirmDialog
      open={open}
      setOpen={handleCloseDialog}
      dialogTitleText={"t.law.file.delete.dialog"}
      alertText={"m.delete.law.file.warning.message"}
      alertType={"warning"}
      onConfirm={confirm}
    ></SimpleConfirmDialog>
  );
};

export default LawFormDeleteFileDialog;
